export const locale = {
    lang: 'tr',
    data: {
      'NOMBREIDIOMAS': {
        'es': 'İspanyolca',
        'en': 'İngilizce',
        'pt': 'Portekizce',
        'zh1': 'Geleneksel Çince',
        'zh2': 'Basitleştirilmiş Çince',
        'tr': 'Türkçe',
        'vi': 'Vietnam',
        'ja': 'Japonca',
        'my': 'Malaya',
        'ro': 'Romen',
        'ru': 'Rusça',
        'fr': 'Fransızca',
        'de': 'Almanca',
        'it': 'İtalyan',
        'nl': 'Flemenkçe',
        'ms': 'Malayca',
        'hi': 'Hintçe',
        'id': 'Endonezya dili',
        'ua': 'Ukrayna',
        'ge': 'Gürcü',
        'uz': 'Özbekçe',
        'az': 'Azerice',
        'kk': 'Kazakistan',
        'hr': 'Hırvat',
        'ar': 'Arap',
        'mk': 'makedonca',
        'lv': 'Letonca',
        'pr': 'Portekizce (Portekiz)',
        'th': 'Tay',
      }
    }
};
